( ($) => {
    $(document).ready(() => {
        $('.scrollbar-info').scroll(function (e) {
            e.stopPropagation();
        });
    });
})(jQuery);